const miscTypes = {
  mutations: {
    SET_SHOW_LOADER: 'SET_SHOW_LOADER'
  },
  actions: {
    TOGGLE_LOADER: 'TOGGLE_LOADER'
  },
  getters: {}
};

export default miscTypes;
